import * as React from 'react';
export const gustoSvg = React.forwardRef(function gustoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F45D48',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.546 18.678V5.145h-3.67v.906a7.652 7.652 0 0 0-4.146-1.215C11.468 4.836 8 8.32 8 12.603s3.468 7.767 7.731 7.767a7.656 7.656 0 0 0 4.103-1.185c0 .119-.006.226-.006.298 0 2.251-1.826 4.086-4.067 4.086a4.045 4.045 0 0 1-2.152-.626l-1.815 3.193a7.656 7.656 0 0 0 3.973 1.12c4.263 0 7.779-3.485 7.779-7.768 0-.166.011-.655 0-.81Zm-7.815-1.99c-2.24 0-4.067-1.834-4.067-4.085 0-2.252 1.826-4.086 4.067-4.086s4.067 1.834 4.067 4.086c0 2.251-1.826 4.086-4.067 4.086v-.001Z',
      fill: '#fff',
    }),
  );
});
gustoSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var gusto = {
  category: 'brand',
  colorable: false,
  name: 'gusto',
  svg: gustoSvg,
};
